import { Client } from "@twilio/conversations";
import { fetchTwilioToken } from "./twilioService";

let twilioClient = null;
export const getTwilioClient = () => twilioClient;

export const initializeTwilioClient = async (token, coachFriendlyName) => {
  try {
    // console.log("inside", token);
    if (!token) throw new Error("Twilio token is required for initialization");

    if (twilioClient === null) {
      twilioClient = new Client(token);

      twilioClient.on("initialized", () => {
        // console.log("Twilio Client is initialized!");
      });

      twilioClient.on("connectionStateChanged", (state) => {
        console.log("Twilio connection state:", state);
      });

      twilioClient.on("messageAdded", (message) => {
        // console.log("New message received:", message);
      });

      twilioClient.on("tokenAboutToExpire", async () => {
        console.warn("Twilio token is about to expire. Refreshing...");
        const newToken = await fetchTwilioToken(coachFriendlyName);
        await twilioClient.updateToken(newToken);
      });

      twilioClient.on("tokenExpired", async () => {
        console.error("Twilio token expired! Fetching new one...");
        const newToken = await fetchTwilioToken(coachFriendlyName);
        if (newToken) {
          await twilioClient.updateToken(newToken);
        } else {
          twilioClient = null;
        }
      });
    }

    return twilioClient;
  } catch (error) {
    console.error("Error initializing Twilio Client:", error);
    throw error;
  }
};
